import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

export default function Goals() {
  const [goals, setGoals] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api('/hcm/my-goals').then(r => r.ok ? r.json() : []).then(setGoals).catch(() => {});
  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {...form, targetDate: form.targetDate || null, progress: parseInt(form.progress) || 0};
    if (form.id) { await api(`/hcm/my-goals/${form.id}`, {method: 'PUT', body: JSON.stringify(body)}); }
    else { await api('/hcm/my-goals', {method: 'POST', body: JSON.stringify(body)}); }
    setForm(null); load();
  };

  const statusColor = (s) => s === 'completed' ? 'bg-green-100 text-green-800' : s === 'on_hold' ? 'bg-gray-100 text-gray-600' : 'bg-blue-100 text-blue-800';

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">My Goals</h2>
        <button onClick={() => setForm({title: '', description: '', targetDate: '', status: 'in_progress', progress: 0})} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">+ New Goal</button>
      </div>

      {form && (
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 mb-6 space-y-4">
          <h3 className="text-lg font-semibold text-gray-900">{form.id ? 'Edit Goal' : 'New Goal'}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Title *</label><input required value={form.title} onChange={e => setForm({...form, title: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Target Date</label><input type="date" value={form.targetDate} onChange={e => setForm({...form, targetDate: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select value={form.status} onChange={e => setForm({...form, status: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                <option value="in_progress">In Progress</option><option value="completed">Completed</option><option value="on_hold">On Hold</option>
              </select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Progress (%)</label><input type="number" min="0" max="100" value={form.progress} onChange={e => setForm({...form, progress: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" /></div>
          </div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Description</label><textarea rows={2} value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" /></div>
          <div className="flex gap-2">
            <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 text-sm">{form.id ? 'Save' : 'Create'}</button>
            <button type="button" onClick={() => setForm(null)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 text-sm">Cancel</button>
          </div>
        </form>
      )}

      <div className="space-y-4">
        {goals.map(g => (
          <div key={g.id} className="bg-white rounded-lg shadow p-5">
            <div className="flex items-start justify-between mb-2">
              <div>
                <h3 className="font-semibold text-gray-900">{g.title}</h3>
                {g.description && <p className="text-sm text-gray-500 mt-1">{g.description}</p>}
              </div>
              <div className="flex items-center gap-2">
                <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${statusColor(g.status)}`}>{g.status?.replace('_', ' ')}</span>
                <button onClick={() => setForm({id: g.id, title: g.title, description: g.description || '', targetDate: g.targetDate || '', status: g.status, progress: g.progress})} className="text-sm text-gray-500 hover:text-indigo-600">Edit</button>
                <button onClick={async () => { await api(`/hcm/my-goals/${g.id}`, {method: 'DELETE'}); load(); }} className="text-sm text-gray-500 hover:text-red-600">Delete</button>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div className="bg-indigo-600 h-2 rounded-full transition-all" style={{width: `${g.progress || 0}%`}} />
              </div>
              <span className="text-sm font-medium text-gray-600">{g.progress || 0}%</span>
            </div>
            {g.targetDate && <p className="text-xs text-gray-400 mt-2">Target: {g.targetDate}</p>}
          </div>
        ))}
        {goals.length === 0 && <div className="text-center py-12 bg-white rounded-lg shadow text-gray-500">No goals yet. Set your first goal!</div>}
      </div>
    </Layout>
  );
}
